import React, { useState, useEffect } from "react";
import "./Home.css";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";
import LogEntryForm from "../LogEntryForm/LogEntryForm";
import LogSummary from "../LogSummary/LogSummary";
import LogResults from "../LogResults/LogResults";
import { getData, storeData } from "../../helpers/localStorage";

const Home = () => {
  const initialState = () => getData("data") || [];
  const [state, setState] = useState(initialState);

  const useStyles = makeStyles((theme) => ({
    root: {
        margin: ".5rem 0",
      },
    }));

  const classes = useStyles();

  useEffect(() => {
    storeData("data", state);
  }, [state]);

  const newLogEntryHandler = (val) => {
    val.id = uuidv4();
    let newVal = [...state, val];
    let len = newVal.length;
    if (len > 7) newVal = newVal.slice(1, len);
    setState(newVal);
  };

  const deleteHandler = (id) => {
    console.log("delete handler called");
    storeData("lastState", state);
    let newState = state.filter((i) => {
      return i.id !== id;
    });
    setState(newState);
  };

  return (
    <div className={classes.root}>
      <LogEntryForm change={newLogEntryHandler}></LogEntryForm>
      <LogSummary logs={state}></LogSummary>
      <LogResults logs={state} delete={deleteHandler}></LogResults>
    </div>
  );
};

export default Home;
